<template>
  <div />
</template>

<script setup>
import { watch } from 'vue'
import { selectedExecRoutes } from '../composables/useSelectedExecRoutes'

// Nothing to look at: this rides along in DataTable's toolbar only to reach the map
// beside it. DataTable passes a side component whatever a toolbar component last sent
// it through `send-data`, and gives toolbar components a fixed set of props, so this
// event is the only way the checked routes get from the grid to the map panel.
// It used to hang off the screen-view button, which now belongs to every screen that
// splits - and none of the others have routes to send.

// Passed in automatically by DataTable to every `filters_row_end_components` entry -
// unused here, declared only so it does not fall through onto the root element.
defineProps({
  tableData: {
    type: Array,
    default: () => ([])
  }
})

const emit = defineEmits(['send-data'])

// The grid's list response already includes each route's own `locations` (with
// coordinates/status), so a checked row's markers need no extra fetch - just re-shape
// the checkbox-selected row data.
watch(selectedExecRoutes, (rows) => {
  const routes = (Array.isArray(rows) ? rows : [])
    .filter(row => row?.polyline)
    .map(row => ({
      id: row.id,
      polyline: row.polyline,
      locations: row.locations
    }))

  emit('send-data', routes)
}, { immediate: true, deep: true })
</script>
